




















import { Component, Prop, Ref } from "vue-property-decorator";

import {
  DialogSection,
  DialogForm,
  ScriptChooser
} from "sitewhere-ide-components";
import { VFlex } from "vuetify/lib";

import { IScriptedEventDecoderConfiguration } from "sitewhere-configuration-model";
import { required } from "vuelidate/lib/validators";

@Component({
  components: { VFlex, DialogForm, ScriptChooser },
  validations: {
    scriptId: {
      required
    }
  }
})
export default class ScriptedDecoderFields extends DialogSection {
  @Prop() readonly tenantId!: string;
  @Ref() readonly chooser!: ScriptChooser;

  scriptId: string | null = null;

  /** Reset section content */
  reset(): void {
    if (this.chooser) {
      this.chooser.reset();
    }
    this.scriptId = null;
    this.$v.$reset();
  }

  /** Perform validation */
  validate(): boolean {
    this.$v.$touch();
    return !this.$v.$invalid;
  }

  /** Load form data from an object */
  load(input: IScriptedEventDecoderConfiguration): void {
    this.scriptId = input.scriptId || null;
  }

  /** Save form data to an object */
  save(): IScriptedEventDecoderConfiguration {
    return {
      scriptId: this.scriptId || ""
    };
  }
}
